import { render, staticRenderFns } from "./BookAppearanceV3.vue?vue&type=template&id=3835c5e7"
import script from "./BookAppearanceV3.vue?vue&type=script&lang=js"
export * from "./BookAppearanceV3.vue?vue&type=script&lang=js"
import style0 from "./BookAppearanceV3.vue?vue&type=style&index=0&id=3835c5e7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports